export default __webpack_public_path__ + "static/media/gamebased.9ab2b1a5.jpg";